/**
 * Create coupons context for custom hook
 */
import { createContext } from 'react'

const CouponsContext = createContext({
  fetchCoupon: () => {},
  fetchCouponPublicShow: () => {},
  fetchCoupons: () => {},
});

export default CouponsContext
